import React, { FC, useState, useEffect } from 'react';
import ToggleMode from '../../assets/components/ToggleMode/ToggleMode';
import { useAppDispatch } from '../../assets/hooks/hooks';
import './Header.scss';
import logoDarkTheme from '../../assets/images/logo_theme_dark.svg'
import logoLightTheme from '../../assets/images/logo_theme_light.svg'
import { useNavigate } from 'react-router-dom';
import { initializedActions } from '../../redux/initial-app-slice';
import { Theme, useTheme } from '../../ThemeContext';

const Header: FC = (props) => {
    const { toggleTheme, theme } = useTheme();
    const [checkedValue, setCheckedValue] = useState(theme === Theme.LIGHT);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const logoutChangeHandler = () => {
        localStorage.removeItem("auth");
        dispatch(initializedActions.initializedSuccess(
            {
                userId: -1,
                token: "",
                role: undefined,
                permissions: [],
                userName: "",
                initialized: false,
                theme: theme
            }
        ));

        navigate("auth")
    }

    const handleToggle = () => {
        toggleTheme();
        setCheckedValue(!checkedValue);
    };

    return (
        <div className="header">
            <img
                src={theme === Theme.DARK ? logoDarkTheme : logoLightTheme}
                alt="Avanquest License Manager"
            />
            <div className="header_action_bar">
                <ToggleMode
                    stateChecked={checkedValue}
                    handleToggle={handleToggle}
                />

                <button className="logout_button" onClick={logoutChangeHandler}>
                    Logout
                </button>
            </div>
        </div>
    );
}

export default Header;
